import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type UUID } from '~/types/common';

import { queryKeysCompany } from '../queryKeys';

import { deleteCompanyAliasAddress } from './deleteCompanyAliasAddress';
import { type DeleteCompanyAliasAddressMutationOptions } from './types';

/**
 * Custom hook for deleting a company alias address using mutations.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company-Alias-Addresses/operation/delete_company_address_vadmin_company_alias_address__company_address_uuid__delete
 */
export const useMutationDeleteCompanyAliasAddress = (
  options?: DeleteCompanyAliasAddressMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      aliasAddressId,
      issuerId,
    }: {
      aliasAddressId: UUID;
      issuerId?: UUID;
    }) =>
      deleteCompanyAliasAddress({
        aliasAddressId,
        issuerId,
      }),
    onSettled() {
      void queryClient.invalidateQueries({
        queryKey: queryKeysCompany.getAliasAddresses({}),
      });
    },
    ...options,
  });
};
